// extracted by mini-css-extract-plugin
export default {"root":"Tooltip__root___nFDo8","overlayArrow":"Tooltip__overlayArrow___TQR9e"};